__turbopack_context__.v({
  "overline": "Overline-module__pjMVha__overline",
});
